const settings = {
    server_url: process.env.REACT_APP_SERVER_URL,
    client_url_full: process.env.REACT_APP_CLIENT_URL_FULL,
    client_url_main: process.env.REACT_APP_CLIENT_URL_MAIN,
}

export default settings;